import { Box } from '@mui/material';
import React from 'react';
import useSWR from 'swr';

import { getPostalItemsUrl, tabTypes } from '../../constant';
import { postalFetcher } from '../../helpers';
import PostalItem from '../PostalItem';
import Tab from '../Tab';
import Tabs from '../Tabs';

const PostalItemList: React.FC<{
  setDisplayPostalId: (id: string) => void;
  tab: number;
  setTab: (tab: number) => void;
}> = ({ setDisplayPostalId, tab, setTab }) => {
  const fetchUrl = `${getPostalItemsUrl}?type=${tabTypes[tab]}`;

  const { data: postalList } = useSWR(fetchUrl, postalFetcher, {
    refreshInterval: 10000,
  });

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        padding: '1.25rem 1.5rem',
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        overflow: 'hidden',
      }}
    >
      <Tabs tabIndex={tab}>
        <Tab selected={tab === 0} onClick={() => setTab(0)}>
          未領取
        </Tab>
        <Tab selected={tab === 1} onClick={() => setTab(1)}>
          已領取
        </Tab>
        <Tab selected={tab === 2} onClick={() => setTab(2)}>
          退貨狀態
        </Tab>
      </Tabs>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {postalList?.map((postal) => (
          <PostalItem
            key={postal.id}
            postal={postal}
            showDetail={() => setDisplayPostalId(postal.id)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PostalItemList;
